module.exports = __webpack_public_path__ + "media/win-up.8251f1fd.webm";